export function isInventoryGroup(obj: { type?: string | null | undefined } | null | undefined) {
  return obj?.type === 'Group';
}

export default isInventoryGroup;
